<div class="modal-container">

    <div class="modal-header modal-book modal-head-brb-pad d-inline-block">
      <div class="justify-content-between">
        <div class="filter-body">
          <h4 class="modal-title text-body">Room Amenities</h4>
          <button class="modal-clost-btn" (click)="bsModalRef?.hide()" aria-label="Close">&times;</button>
          <div class="row">
            <div 
                               class="features-grid 
                               ">
                               <div class="d-flex " *ngFor="let unit of amenities">
                                 <fa-icon class="me-2" [icon]="icons.circleCheck"></fa-icon>
                                 <p class="md-caption my-0">{{unit?.name}}</p>
                               </div>
                             </div>
          </div>
        </div>
  
        
       
      </div>
  
  
    </div>
  
  </div>
  